import React from 'react';

import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface FormLabelProps {
  children: React.ReactNode;
  className?: string;
}

export function FormLabel({ children, className }: FormLabelProps) {
  return (
    <div className={cn('bg-muted/50 text-muted-foreground inline-flex h-9 items-center rounded-md px-3', className)}>
      <Label>{children}</Label>
    </div>
  );
}

interface FormErrorProps {
  errors: string[] | undefined;
  className?: string;
}

export function FormError({ errors, className }: FormErrorProps) {
  if (!errors) return null;
  return <div className={cn('text-destructive px-1 text-xs', className)}>{errors[0]}</div>;
}
